import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { useLocation } from "react-router-dom";
import Sidebar from "./Sidebar";
import Content from "./Content";

function SideBarAndContent({ children }) {
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  // Close the mobile drawer on every navigation (i.e. a nav item was tapped),
  // so phone users aren't left staring at the open menu. `location.key` changes
  // on each navigation, including one that changes only the ?tab= part of the
  // address or re-opens the page already showing; opening the drawer does not
  // navigate, so it never closes itself.
  useEffect(() => {
    setMobileOpen(false);
  }, [location.key]);

  return (
    <div className="flex flex-row w-full h-full">
      {/* Mobile top bar with hamburger — hidden on md and up */}
      <div className="md:hidden fixed top-0 left-0 right-0 z-30 h-[56px] bg-dupontBlue flex items-center gap-x-3 px-4">
        <button
          type="button"
          aria-label="Open menu"
          onClick={() => setMobileOpen(true)}
          className="text-white p-2 -ml-2"
        >
          <svg width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
            <line x1="3" y1="6" x2="21" y2="6" />
            <line x1="3" y1="12" x2="21" y2="12" />
            <line x1="3" y1="18" x2="21" y2="18" />
          </svg>
        </button>
        <span className="text-white font-blackletter text-[22px] leading-none">du Pont Circle</span>
      </div>

      {/* Backdrop behind the drawer (mobile only, when open) */}
      {mobileOpen && (
        <div
          className="md:hidden fixed inset-0 bg-black/40 z-40"
          onClick={() => setMobileOpen(false)}
          aria-hidden="true"
        />
      )}

      {/* Sidebar — a slide-in drawer on phones, a static column on desktop */}
      <div
        className={`fixed md:static top-0 left-0 h-full z-50 md:z-auto overflow-y-auto transform transition-transform duration-200 ease-in-out ${
          mobileOpen ? "translate-x-0" : "-translate-x-full"
        } md:translate-x-0`}
      >
        {/* Close button (mobile only) */}
        <button
          type="button"
          aria-label="Close menu"
          onClick={() => setMobileOpen(false)}
          className="md:hidden absolute top-3 right-3 z-10 text-white/80 p-1"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
            <line x1="6" y1="6" x2="18" y2="18" />
            <line x1="18" y1="6" x2="6" y2="18" />
          </svg>
        </button>
        <Sidebar />
      </div>

      <Content>{children}</Content>
    </div>
  );
}

SideBarAndContent.propTypes = {
  children: PropTypes.node.isRequired,
};

export default SideBarAndContent;
